// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDropGroupMention } from '../models/ApiDropGroupMention';
import { HttpFile } from '../http/http';

export class ApiWaveNotificationPreferences {
    'subscribed': boolean;
    'enabled_group_notifications': Array<ApiDropGroupMention>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "subscribed",
            "baseName": "subscribed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "enabled_group_notifications",
            "baseName": "enabled_group_notifications",
            "type": "Array<ApiDropGroupMention>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveNotificationPreferences.attributeTypeMap;
    }

    public constructor() {
    }
}
